import { ITreeNode } from "../../../../../libs/ts/WorkflowTree/Nodes/ITreeNode";
import { TerminateView } from "../elements/nodeViews/TerminateView";
import { JbpTreeNodeData } from "../treeExtensions/JbpTreeNodeData";
import { IJbpChildNodeRelationship } from "../treeExtensions/IJbpChildNodeRelationship";
import { IViewFactory } from "./IViewFactory";

export class TerminateFactory extends IViewFactory {
    public override MakeView(node: ITreeNode<JbpTreeNodeData, IJbpChildNodeRelationship>, mpan: string, serviceLine: string): JSX.Element {
        return <TerminateView key={node.Identifier()} node={node} mpan={mpan} serviceLine={serviceLine} />;
    }
}
